<div class="tw-w-full tw-relative tw-h-screen tw-bg-gray-100 tw-rounded-t-3xl tw-overflow-hidden">
  <span class="tw-w-20 tw-h-[3px] tw-rounded-lg tw-absolute tw-top-1 tw-left-1/2 -tw-translate-x-1/2 tw-bg-[#D9D9D9]"></span>
  <div class="tw-w-full tw-flex tw-justify-between tw-items-center tw-px-4 tw-pb-4 tw-pt-5 tw-tracking-[0.5px] tw-bg-white">
    <div class="tw-flex tw-items-center tw-gap-2">
      <img src="https://cdn.cureskin.com/app/img/ai-star.svg" alt="">
      <h1 class="tw-text-300 tw-font-semibold" i18n="@@cureskinHealthAssistant">Cureskin AI Health Assistant</h1>
    </div>
    <div class="tw-text-gray-500 tw-text-500 tw-font-bold" (click)="closePopup()">&#10005;</div>
  </div>
  <div class="tw-w-full tw-bg-gray-100 tw-px-1 tw-relative">
    <ng-container *ngIf="initialLoading">
      <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-py-2">
        <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-t-teal-500"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="!initialLoading">
      <div #scrollContainer class="tw-h-[65dvh] xs:tw-h-[70dvh] tw-overflow-y-scroll tw-py-3 tw-px-3"
           [ngClass]="(extraQuestions?.length === 0 ? 'tw-pb-15' : 'tw-pb-11')"
           (scroll)="onScroll()">
        <div *ngIf="loadingOldMessages" class="tw-w-full tw-flex tw-justify-center tw-items-center tw-py-2">
          <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-t-teal-500"></div>
        </div>
        <ng-container *ngFor="let chat of allChats; let i = index">
          <div #chatMsg class="chat-bubble tw-w-full tw-flex tw-text-300" [ngClass]="{'tw-justify-end tw-text-gray-800 ': chat?.get('Owner') === 'USER', 'tw-justify-start tw-text-gray-700': chat?.get('Owner') === 'BOT'}">
            <div *ngIf="chat?.get('Owner') === 'USER'" class="tw-bg-teal-300 tw-p-3 tw-rounded-t-xl tw-rounded-bl-xl tw-w-fit tw-mb-4 tw-max-w-[85%]">{{ chat?.get('Message') }}</div>
            <div *ngIf="chat?.get('Owner') === 'BOT'" class="tw-w-fit tw-max-w-[90%] tw-text-wrap tw-overflow-clip tw-mb-4 tw-flex tw-items-start tw-gap-2">
              <img src="/assets/icons/ai_ball_star.svg" class="tw-w-10" />
              <div class="tw-flex tw-flex-col tw-gap-2">
                <div class="tw-bg-white tw-border-gray-200 tw-p-3 tw-rounded-b-xl tw-rounded-tr-xl" [innerHTML]="convertTextToHtml(chat?.get('Message'))"></div>
                <div *ngIf="chat?.get('Owner') === 'BOT' && chat.get('Inputs')?.length && chat?.get('Inputs')[0]?.type !== 'TEXT' && i === allChats?.length - 1" class="tw-w-full tw-flex tw-flex-col tw-gap-2 tw-justify-start tw-items-start tw-pr-2 tw-mb-4">
                  <ng-container *ngFor="let inp of chat.get('Inputs'); let idx = index">
                    <span class="tw-bg-white tw-border tw-border-teal-500 tw-rounded-xl tw-py-2 tw-px-4 tw-shadow-z1 tw-text-teal-600" (click)="handleInputClick(chat, inp)">
                      {{ inp.text }}
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="tw-w-full tw-max-w-[90%] tw-mt-2 tw-flex tw-items-start tw-gap-2 tw-mb-10" *ngIf="showThinking">
          <img src="/assets/icons/ai_ball_star_faded.svg" class="tw-w-10" />
          <div class="tw-w-full tw-flex tw-flex-col">
            <span class="tw-mb-3 tw-text-200 tw-text-gray-500" i18n="@@thinking">Thinking...</span>
            <div class="tw-flex tw-flex-col tw-w-full tw-mt-1">
              <div class="thinking-bar thinking-bar-1 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
              <div class="thinking-bar thinking-bar-2 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
              <div class="thinking-bar thinking-bar-3 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
            </div>
          </div>
        </div>
        <div class="tw-w-full tw-pt-10 tw-pb-6" *ngIf="extraQuestions?.length > 0 && !showThinking && latestMessage?.get('questionId') !== 'requestToScheduleDoctorCall'">
          <h1 class="tw-text-400 tw-mb-2 gradient-text" i18n="@@peopleAlsoAsk">People also ask...</h1>
          <div class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-overflow-x-auto hide-scrollbar tw-pb-2 tw-scroll">
            <ng-container *ngFor="let question of extraQuestions">
              <div class="tw-w-fit tw-text-nowrap tw-text-gray-700 tw-bg-white tw-flex tw-justify-start tw-gap-2 tw-py-3 tw-pl-2 tw-pr-7 tw-rounded-t-xl tw-rounded-br-xl" (click)="askExtraQuestion(question)">
                <img src="https://cdn.cureskin.com/app/img/ai-star-gray.svg" class="tw-w-3" alt="">
                {{ question.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="tw-pb-4 tw-left-0 tw-right-0 tw-w-full tw-fixed tw-bottom-0 tw-bg-gray-100 tw-pt-1" *ngIf="latestMessage?.get('questionId') !== 'requestToScheduleDoctorCall'">
      <div class="tw-w-full tw-px-4">
        <div class="tw-w-full tw-flex tw-items-center tw-border tw-border-gray-200 tw-shadow-z9 tw-rounded-3 tw-bg-white">
          <textarea #msgInput class="tw-bg-white tw-py-3 tw-pl-3 tw-pr-2 tw-rounded-2xl tw-w-full tw-overflow-y-auto tw-max-h-[120px] tw-min-h-[48px] tw-border-none"
            [disabled]="showThinking || !allChats.length"
            (keydown.enter)="$event.preventDefault(); sendMessage(msgInput.value); msgInput.value=''"
            rows="1"
            type="text"
            name="message"
            placeholder="Ask Anything..." ></textarea>
          <div
            class="tw-w-fit tw-p-1.5 tw-mr-3 tw-rounded-full"
            [ngClass]="{'tw-bg-gray-300': !msgInput.value.trim(), 'tw-bg-teal-600': msgInput.value.trim()}"
            (click)="sendMessage(msgInput.value); msgInput.value=''">
            <img src="/assets/chat-send.svg" class="tw-w-6" />
          </div>
        </div>
      </div>
    </div>
    </ng-container>
  </div>
</div>
